import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, OnChanges, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { StateService } from '../../shared/state/state.service';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../components/general/base/base.component';
import { MapService } from '../../shared/map/map.service';
import { DOCUMENT } from '@angular/common';


/**
 * Map control component. This draws control bar on Map UI. Communication with MapComponent is done with ngrx/store.
 */
@Component({
  selector: 'qm-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlsComponent extends BaseComponent implements OnInit, OnDestroy {
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private mapService: MapService) {
    super();
    this.name = 'ControlsComponent';
  }

  /**
   * Angular event, run when view is initialized (dom is rendered etc.)
   * Listen for changes in MapState.
   */
  ngOnInit() {
  }

  /**
   * Angular destructor function
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Toggle fullscreen view for app.
   */
  public toggleFullScreen(): Promise<void> {
    if (document.fullscreenElement) {
      return this.document.exitFullscreen();
    } else {
      return this.document.body.requestFullscreen({
        navigationUI: 'hide',
      });
    }
  }

  public zoomIn() {
    this.mapService.zoomIn();
  }

  public zoomOut() {
    this.mapService.zoomOut();
  }

}
